<div class="header">
  <img class="logo" src="assets/svg/logo.svg" alt="logo" />

  <div class="menu">
    <div
      class="content-menu"
      routerLink="./home"
      routerLinkActive="active"
      *displayAllowed="'sapore.survey.home.get'"
    >
      <div class="desc">
        <img src="assets/img/home.png" alt="home" width="20px" />
        Home
      </div>
      <p class="border"></p>
    </div>
    <div
      class="content-menu"
      routerLink="./registration"
      routerLinkActive="active"
      *displayAllowed="permissionsRegistration"
    >
      <div class="desc">
        <img src="assets/img/doc.png" alt="home" width="22px" />
        Cadastro
      </div>
      <p class="border"></p>
    </div>
    <div class="content-menu" routerLink="./polls" routerLinkActive="active">
      <div class="desc">
        <img src="assets/img/search.png" alt="home" width="22px" />
        Pesquisas
      </div>
      <p class="border"></p>
    </div>
    <div class="content-menu" routerLink="./report" routerLinkActive="active">
      <div class="desc">
        <img src="assets/img/monitoring.png" alt="home" width="22px" />
        Relatório
      </div>
      <p class="border"></p>
    </div>
  </div>

  <div class="name-logout">
    <div class="profile-img">
      @if (photo) {
      <img
        class="profile-img"
        [src]="
          photo.includes('base64') ? 'data:image/png;base64,' + photo : photo
        "
        alt="profile"
      />
      } @else {
      {{ shortName }}
      }
    </div>
    <div>
      <p class="name">{{ unique_name }}</p>
      <p class="profile">{{ role }}</p>
    </div>
    <img
      class="logout"
      src="assets/svg/SignOut.svg"
      alt="logout"
      (click)="logout()"
    />
  </div>
</div>
